import { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { Box, IconButton, Snackbar, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { LanguageContext } from '../../../../../context/languageContext';
import { DataGridPremium, useGridApiRef } from '@mui/x-data-grid-premium';
import EditSkillingSheet from './editSpecialtySkills';

export default function SpecialtySkillingSheet({user}) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isEditSkillingSheetModalOpen, setisEditSkillingSheetModalOpen] =
    useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsSnackbarOpen(false);
  };
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const { translations } = useContext(LanguageContext);
  const apiRef = useGridApiRef();

  const skillingSheetReport = translations => ({
    apiEndpoint: `${process.env.REACT_APP_ENDPOINT_ADMIN}/workforce/skilling-sheet/specialty/get`,
    columns: [
      {
        field: 'name',
        headerName: 'Name',
      },
      {
        field: 'location',
        headerName: 'Location',
      },
      {
        field: 'stolenReports',
        headerName: 'Stolen Reports',
        description: '(CO, NE, NJ, RI, WA, WI)',
      },
      {
        field: 'stolenTickets',
        headerName: 'Stolen Tickets',
        description: '(MS, CT, NY)',
      },
      {
        field: 'txStolen',
        headerName: 'Texas Stolen',
      },
      {
        field: 'imo',
        headerName: 'IMO',
      },
      {
        field: 'nrcHelpdesk',
        headerName: 'NRC Helpdesk',
      },
      {
        field: 'sap',
        headerName: 'SAP',
      },
      {
        field: 'fwdToSite',
        headerName: 'Forward to Site',
      },
      {
        field: 'supCalls',
        headerName: 'Supervisor Calls',
      },
      {
        field: 'imoTrainer',
        headerName: 'IMO Trainer',
      },
      {
        field: 'dispatchEscalations',
        headerName: 'Dispatch Escalations',
      },
      {
        field: 'workforce',
        headerName: 'Workforce Backup',
      },
      {
        field: 'dsrLine',
        headerName: 'DSR Line',
      },
      {
        field: 'tier2',
        headerName: 'Tier 2',
      },
      {
        field: 'flLiveAlerts',
        headerName: 'Florida Live Alerts',
      },
      {
        field: 'blitzz',
        headerName: 'Blitzz',
      },
      {
        field: 'EDIT',
        headerName: 'Edit',
        renderCell: params => {
          return (
            <IconButton
              onClick={() => handleEditSkillingSheetModalOpenClose(params.row)}
            >
              <EditIcon />
            </IconButton>
          );
        },
      },
    ],
  });

  const skillingSheet = skillingSheetReport(translations);

  const handleEditSkillingSheetModalOpenClose = entry => {
    setCurrentEntry(isEditSkillingSheetModalOpen ? null : entry);
    setisEditSkillingSheetModalOpen(!isEditSkillingSheetModalOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(skillingSheet.apiEndpoint);
      setData({
        rows: response.data,
      });
    };
    fetchData();
  }, [skillingSheet.apiEndpoint]);

  useEffect(() => {
    if (!data) return;

    const timeoutId = setTimeout(() => {
      apiRef.current.autosizeColumns({
        expand: true,
        includeHeaders: true,
        includeOutliers: true,
      });
      setIsLoading(false);
    });

    return () => clearTimeout(timeoutId);
  }, [apiRef, data]);

  const handleRefresh = async () => {
    setIsLoading(true);
    const response = await axios.get(skillingSheet.apiEndpoint);
    setData({
      rows: response.data,
    });
  };

  return (
    <Box
      sx={{
        height: '90vh',
        width: '100%',
        display: 'flex',
        p: 2,
      }}
    >
      <DataGridPremium
        {...data}
        loading={isLoading}
        columns={skillingSheet.columns}
        disableRowSelectionOnClick
        showToolbar
        sx={{ fontFamily: 'BrightstarSans-Regular' }}
        apiRef={apiRef}
        initialState={{ pinnedColumns: { left: ['name'], right: ['EDIT'] } }}
      />
      {isEditSkillingSheetModalOpen && (
        <EditSkillingSheet
          handleRefresh={handleRefresh}
          isOpen={isEditSkillingSheetModalOpen}
          handleClose={handleEditSkillingSheetModalOpenClose}
          entry={currentEntry}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarMessage={setSnackbarMessage}
          setSnackbarSeverity={setSnackbarSeverity}
          user={user}
        />
      )}
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          variant='filled'
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
